import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";

//create wrapper for current route
//take component from current route -> component: variableName, gather all props from Component
export default function PrivateRoute({ component: Component, ...rest }) {
  const { currentUser } = useAuth();
  return (
    <Route
      // pass rest of the props props
      {...rest}
      //define own render, takes in props, check if currentUser render component with props else render redirect to login
      render={(props) => {
        return currentUser ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        );
      }}
    ></Route>
  );
}
